import { render, staticRenderFns } from "./button-send.vue?vue&type=template&id=aab288ae&scoped=true&lang=pug&"
import script from "./button-send.vue?vue&type=script&lang=js&"
export * from "./button-send.vue?vue&type=script&lang=js&"
import style0 from "./button-send.vue?vue&type=style&index=0&id=aab288ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab288ae",
  null
  
)

export default component.exports